<template>
  <div class="container_self">
    <el-row class="table_parent">
      <el-row style="margin: 10px 0 15px 0"
        ><el-button size="mini" type="success" icon="el-icon-plus" @click="addGam"
          >添加GAM账号</el-button
        ></el-row
      >
      <h3>GAM账号管理</h3>

      <el-row v-loading="loading">
        <el-table :data="gamList">
          <el-table-column
            label="ID"
            prop="id"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column
            label="客户ID"
            prop="customerId"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="客户名称"
            prop="customerName"
            align="center"
          ></el-table-column>
          <el-table-column
            label="登录账号"
            prop="account"
            align="center"
          ></el-table-column>
          <el-table-column
            label="报告地址"
            prop="reportUrl"
            align="center"
          ></el-table-column>
          <el-table-column
            label="NetworkCode"
            prop="networkCode"
            align="center"
          ></el-table-column>
          <!-- <el-table-column label="百分比系数" align="center">
            <template slot-scope="scope">
              <span style="color: #2cfd01">{{ scope.row.percentage }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            label="创建时间"
            prop="createTime"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="280">
            <template slot-scope="scope">
              <div>
                <el-button type="success" size="mini" @click="reportIdManager(scope.row)">reportId管理</el-button>
                <el-button type="primary" size="mini" @click="updateGam(scope.row)"
                  >更新</el-button
                >
                <el-button type="danger" size="mini" @click="deleteGam(scope.row)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searcForm.currentPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="searcForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>

    <el-dialog
      :title="string + 'GAM账号'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form
        :model="form"
        label-width="120px"
        :rules="rules"
        ref="ruleForm"
        size="mini"
        class="demo-ruleForm search_parent"
      >
        <el-form-item label="所属客户" prop="customerId">
          <el-select
            v-model="form.customerId"
            remote
            reserve-keyword
            filterable
            placeholder="请输入关键词"
            :remote-method="searchCustom"
            @change="customerIdChange"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号" prop="account">
          <el-input v-model="form.account"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="账号类型">
          <el-select v-model="accountType" @change="netWorkChange">
            <el-option
              v-for="(item, index) in networkCodeArr"
              :value="item.name"
              :label="item.name"
              :key="item.code + '_' + index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户ID" prop="fetchUserId">
          <el-input v-model="form.fetchUserId"></el-input>
          <!-- <el-select
                        v-model="form.fetchUserId"
                        remote
                        reserve-keyword
                        filterable
                        placeholder="请输入关键词"
                        :remote-method="searchUser"
                    >
                        <el-option
                        v-for="item in optionsUser"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select> -->
        </el-form-item>
        <el-form-item label="是否启用">
          <el-select v-model="form.enabled">
            <el-option :value="1" label="是"></el-option>
            <el-option :value="0" label="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="NetworkCode" prop="networkCode">
          <el-select v-model="form.networkCode" disabled>
            <el-option
              v-for="(item, index) in networkCodeArr"
              :value="item.pageSize"
              :label="item.name"
              :key="item.code + '_' + index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="百分比系数" prop="percentage">
          <el-input v-model="form.percentage"></el-input>
        </el-form-item> -->
        <el-form-item label="报告ID" prop="reportId">
          <el-input v-model="form.reportId"></el-input>
        </el-form-item>
        <el-form-item label="报告地址" prop="reportUrl">
          <el-input v-model="form.reportUrl"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
export default {
  data() {
    return {
      accountType:"",
      gamList: [],
      searcForm: {
        account: "",
        pageSize: 20,
        currentPage: 1,
      },
      string: "",
      dialogFormVisible: false,
      form: {
        account: "",
        customerId: "",
        enabled: "",
        fetchUserId: "",
        id: "",
        networkCode: "",
        password: "",
        percentage: "100",
        reportId: "",
        reportUrl: "",
        type: "",
      },
      rules: {
        customerId: { required: true, message: "选择客户", trigger: "blur" },
        account: { required: true, message: "请输入登录账号", trigger: "blur" },
        fetchUserId: { required: true, message: "请输入用户ID", trigger: "blur" },
        networkCode: { required: true, message: "请输入登录密码", trigger: "blur" },
        percentage: { required: true, message: "请输入百分比系数", trigger: "blur" },
        reportId: { required: true, message: "请输入报告ID", trigger: "blur" },
        reportUrl: { required: true, message: "请输入报告地址", trigger: "blur" },
        password: { required: true, message: "请输入登录密码", trigger: "blur" },
      },
      options: [],
      total: 0,
      loading: false,
      optionsUser: [],
      networkCodeArr:[],
      isGoogle: true,
    };
  },
  methods: {
    handleSizeChange(val) {
      this.searcForm.pageSize = val;
      this.searcForm.currentPage = 1;
      this.getList(this.searcForm);
    },
    customerIdChange(val){
      this.options.forEach(item=>{
        if(val===item.id){
          this.form.customerName=item.name;
        }
      })
    },
    handleCurrentChange(val) {
      this.searcForm.currentPage = val;
      this.getList(this.searcForm);
    },
    async getList(params) {
      this.loading = true;
      await axiosGet("/api/gam/account/list", {
        account: params.account,
        pageSize: params.pageSize,
        currentPage: params.currentPage,
      }).then((res) => {
        if (res.code == 0) {
          this.gamList = res.data.records;
          this.total = res.data.total;
        }
      });
      this.loading = false;
    },
    async submitForm(formName) {
      const valid = await new Promise((resolve) => {
        this.$refs[formName].validate((valid) => {
          resolve(valid);
        });
      });
      if (valid) {
        let url = this.form.id ? "/api/gam/account/update" : "/api/gam/account/add";
        if(!this.form.id){
          delete this.form.id;
        }
        axiosPost(url, this.form, "JSON").then((res) => {
          if (res.code == 0) {
            this.accountType="";
            this.$message({ message: "成功", type: "success" });
            this.dialogFormVisible = false;
            this.getList(this.searcForm);
          }
        });
      }
    },
    searchCustom(keyword) {
      if (keyword != "") {
        this.getCustomList({ currentPage: 1, pageSize: 20, keyword: keyword });
      }
    },
    async getCustomList(params) {
      await axiosGet(
        "/api/customer/list?currentPage=" +
          params.currentPage +
          "&pageSize=" +
          params.pageSize +
          "&keyword=" +
          params.keyword
      ).then((res) => {
        if (res.code == 0) {
          this.options = res.data.records;
        }
      });
    },
    updateGam(row) {
      this.string = "更新";
      let rows=JSON.parse(JSON.stringify(row));
      this.networkCodeArr.forEach(element => {
        if(element.type===rows.type){
          this.accountType=element.type;
        }
      });
      this.form = rows;
      this.dialogFormVisible = true;
    },
    deleteGam(row) {
      this.$confirm("是否要删除 " + row.customerName + " 的GAM账号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          axiosPost("/api/gam/account/delete", { id: row.id }, "JSON").then((res) => {
            if (res.code == 0) {
              this.$message({ message: "删除成功", type: "success" });
              this.getList(this.searcForm);
            }
          });
        })
        .catch(() => {});
    },
    resetForm() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields(); // 重置表单验证
      }
      // this.dialogFormVisible=false;
      this.form = {
        customerName: "",
        account: "",
        customerId: "",
        enabled: 1,
        fetchUserId: "",
        id: "",
        networkCode: "",
        password: "",
        percentage: "100",
        reportId: "",
        reportUrl: "",
        type: "",
      };
      this.accountType="";
    },
    addGam() {
      this.dialogFormVisible = true;
      this.resetForm();
      this.string = "新增";
    },
    searchUser(keyword) {
      if (keyword != "") {
        this.getUserList({ currentPage: 1, pageSize: 20, keyword: keyword });
      }
    },
    async getUserList(params) {
      let res = await axiosGet("/api/user/list", {
        currentPage: 1,
        pageSize: 20,
        keyword: params.keyword,
      });
      if (res.code == 0) {
        this.optionsUser = res.data.records;
      }
    },
    netWorkChange(val) {
      this.networkCodeArr.forEach((element) => {
        if (val == element.name) {
          console.log(element)
          this.form.networkCode = element.networkCode||"";
          this.form.reportUrl=element.url;
          this.form.type=element.type;
        }
      });
    },
    getNetworkCode() {
      axiosGet("/api/gam/account/types").then((res) => {
        if (res.code == 0) {
          if(res.data.length){
            res.data.forEach(item=>{
              if(item.type==='google'){
                item.pageValue=item.type;
              }else{
                item.pageValue=item.type;
              }
            })
          }
          this.networkCodeArr = res.data || [];
          console.log(this.networkCodeArr)
        }
      });
    },
    reportIdManager(row){
      sessionStorage.setItem('reportId',row.reportId);
      sessionStorage.setItem("gamCustomerId",row.customerId);
      this.$router.push('/ReportId');
    }
  },
  mounted() {
    this.getNetworkCode();
    this.getList(this.searcForm);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/GamManager/gamManager.vue